import templateVideoConferenceInvite from './videoConferenceInvite.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, videoConferenceService, uiService) {
      'ngInject';

      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onVideoConferenceInvite(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                clients: _params.clients,
                contacts: _params.contacts,
                accounts: _params.accounts,
                partners: _params.partners,
                currentAccount: _params.currentAccount,
                idTicket: _params.idTicket,
                idWorkflow: _params.idWorkflow
              },
              template: templateVideoConferenceInvite,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (result) {
              uiService.toast({
                text: {
                  p1: 'Video Conference invite',
                  p2: 'is being prepared',
                  p3: 'please wait'
                },
                progress: true,
                warn: true,
                delay: 200
              });
              videoConferenceService.invite(result).then(function (data) {
                if (!data.status) {
                  uiService.toast({
                    text: {
                      p1: 'Video Conference',
                      p2: 'invite',
                      p3: 'has failed'
                    },
                    warn: true
                  });
                } else {
                  ctrl.onFinished({ url: data.url });
                }
              });
            });

          function dialogController(
            $mdDialog,
            clients,
            contacts,
            accounts,
            partners,
            currentAccount,
            idTicket,
            idWorkflow
          ) {
            const ctrl = this;
            ctrl.selectedClients = [];
            ctrl.selectedContacts = [];
            ctrl.selectedAccounts = [];
            ctrl.selectedPartners = [];
            ctrl.participants = [];
            ctrl.currentAccount = currentAccount;
            ctrl.clients = clients;
            ctrl.contacts = contacts;
            ctrl.accounts = _.filter(accounts, function (account) {
              return account.id !== ctrl.currentAccount.id;
            });
            ctrl.partners = partners;
            ctrl.idTicket = idTicket;
            ctrl.idWorkflow = idWorkflow;
            ctrl.selectedAccounts.push({
              name: ctrl.currentAccount.getName(),
              email: ctrl.currentAccount.getEmail(),
              isHost: true,
              bsCode:
                ctrl.currentAccount.integrations &&
                ctrl.currentAccount.integrations.bankStatements &&
                ctrl.currentAccount.integrations.bankStatements.code
                  ? ctrl.currentAccount.integrations.bankStatements.code
                  : null
            });

            ctrl.confirm = function () {
              ctrl.participants = _.union(
                ctrl.selectedClients,
                ctrl.selectedContacts,
                ctrl.selectedAccounts,
                ctrl.selectedPartners
              );

              if (ctrl.participants.length && ctrl.participants.length > 1) {
                $mdDialog.hide({
                  idTicket: ctrl.idTicket,
                  idWorkflow: ctrl.idWorkflow,
                  participants: ctrl.participants
                });
              } else {
                uiService.toast({
                  text: {
                    p1: 'One or more',
                    p2: 'person(s)',
                    p3: 'must be selected'
                  },
                  warn: true
                });
              }
            };
            ctrl.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
